export default __webpack_public_path__ + "static/media/A3.fcc0d69b.jpg";